import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { REGISTRATION_FLOW_TYPE } from '../constants/sessionStorage';

import { selectApplication } from '../store/selectors/applicationSelectors';
import { REGISTRATION_FLOW_TYPES } from '../util/constants';
import { retrieveFromSessionStorage } from '../util/helpers/sessionStorageHelper';

// useSessionStorage is used on Create Account Page:
// User is not logged in so we cant access the application. It takes true or false value.
// If True we will access from the session storage, if it is false we will access the application.

const useAipFlow = (useSessionStorage = false) => {
  const [isAipFlow, setIsAipFlow] = useState(false);
  const Application = useSelector(selectApplication);
  const registrationFlowType = retrieveFromSessionStorage(
    REGISTRATION_FLOW_TYPE,
  );

  useEffect(() => {
    if (!useSessionStorage) {
      if (Application.RegistrationFlowType === 2) {
        setIsAipFlow(true);
        return;
      }

      if (
        Application.RegistrationFlowType === 1 &&
        registrationFlowType === REGISTRATION_FLOW_TYPES.AIP
      ) {
        setIsAipFlow(false);
        return;
      }
      if (registrationFlowType === REGISTRATION_FLOW_TYPES.AIP) {
        setIsAipFlow(true);
        return;
      }
      setIsAipFlow(false);
      return;
    }

    setIsAipFlow(registrationFlowType === REGISTRATION_FLOW_TYPES.AIP);
  }, [
    Application,
    Application.RegistrationFlowType,
    registrationFlowType,
    useSessionStorage,
  ]);

  return { isAipFlow };
};

export default useAipFlow;
